import React from 'react';

import { FormattedMessage } from 'react-intl';

import AssignedToFilterPill from '../../../../../components/actionable-filter-pill/connected/shipping/assigned-to';
import { ASSIGNED_TO } from '../../../../../filters/constants';
import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import messages from './messages';

export default {
  id: ASSIGNED_TO,
  displayName: <FormattedMessage {...messages.assignedTo} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'AssignedTo',
  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },
  shouldHideActionButtons: true,
  allowsMultipleSelection: true,
  actionableFilterPill: AssignedToFilterPill,
};
